import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axiosInstance";

export const createGroup = createAsyncThunk(
  "social/createGroup",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { name } = formInfo;
      const res = await api.post("group/create", { name });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getUserGroups = createAsyncThunk(
  "social/getUserGroups",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("group/mygroups");
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const inviteUserToGroup = createAsyncThunk(
  "social/inviteUserToGroup",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { group_id, email } = formInfo;
      const res = await api.post(`group/${group_id}/invite`, { email });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getGroupInvites = createAsyncThunk(
  "social/getGroupInvites",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { group_id } = formInfo;
      const res = await api.get(`group/${group_id}/invites`);
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getUserInvites = createAsyncThunk(
  "social/getUserInvites",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("group/myinvites");
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const acceptGroupInvite = createAsyncThunk(
  "social/acceptGroupInvite",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { invite_id } = formInfo;
      const res = await api.post(`group/invite/${invite_id}/accept`, {});
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const declineGroupInvite = createAsyncThunk(
  "social/declineGroupInvite",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { invite_id } = formInfo;
      const res = await api.post(`group/invite/${invite_id}/decline`, {});
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getGroupMembers = createAsyncThunk(
  "social/getGroupMembers",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { group_id } = formInfo;
      const res = await api.get(`group/${group_id}/members`);
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const leaveGroup = createAsyncThunk(
  "social/leaveGroup",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { group_id } = formInfo;
      const res = await api.post(`group/${group_id}/leave`, {});
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const kickMemberFromGroup = createAsyncThunk(
  "social/kickMemberFromGroup",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { group_id, email } = formInfo;
      const res = await api.post(`group/${group_id}/kick`, { email });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getGroupActivity = createAsyncThunk(
  "social/getGroupActivity",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { group_id } = formInfo;
      const res = await api.get(`group/${group_id}/activity`);
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getNotifications = createAsyncThunk(
  "social/getNotifications",
  async (formInfo, { rejectWithValue }) => {
    try {
      const page = formInfo?.page || 1;
      const numrows = formInfo?.numrows || 20;
      const res = await api.get(`notifications?page=${page}&numrows=${numrows}`);
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getUnreadCount = createAsyncThunk(
  "social/getUnreadCount",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("notifications/unread-count");
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const markNotificationsRead = createAsyncThunk(
  "social/markNotificationsRead",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { notification_ids } = formInfo;
      const res = await api.post("notifications/read", { notification_ids });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const markAllNotificationsRead = createAsyncThunk(
  "social/markAllNotificationsRead",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.post("notifications/read-all", {});
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);
